<template>
  <div id="app">
    <section id="recall">
      <div class="container">
        <div class="row">
          <div class="col-md-8 offset-md-2">
            <div class="footer-text">
              <img :src='"../assets/images/email-blue.png"' alt="email">
              <h2 class="title text-center md-margin-top">{{ $t('recallForm.readyToIncreaseYourSales') }}</h2>
              <h2 class="title text-center md-margin-top"><span>{{ $t('recallForm.writeToUs') }}</span></h2>
              <p> {{ $t('recallForm.underTitle') }}</p>
              <form
                @submit.prevent="sendEmail()"
                class="footer-form">
                <div class="form-group">
                  <input class="form-control" required v-model="name" name="NAME" id="mce-NAME"
                         :placeholder="$t('recallForm.yourName')"/>
                  <input class="form-control" required v-model="company" name="Company" id="mce-Company"
                         :placeholder="$t('recallForm.yourCompany')"/>
                  <div class="title text-center md-margin-top"
                       v-bind:style="{ color: isShow ? 'lightcoral' : 'white',  textColor: isShow ? 'white' : 'white'}">
                    {{ phoneValidationMsg }}
                  </div>
                  <the-mask class="form-control"  v-model="phone" id="mce-PHONE" mask="+38(0##)###-##-##" type="tel"
                            :masked=true
                            :placeholder="$t('recallForm.yourPhone')"
                  ></the-mask>
                  <vue-recaptcha
                    ref="recaptcha"
                    style="display: inline-block;"
                    :language="$t('language').valueOf()"
                    :sitekey="sitekey"
                    @verify="register"
                    @expired="onCaptchaExpired"
                  />
                </div>
                <div class="form-button">
                  <v-btn
                    name="Button"
                    @click="sendEmail"
                    class="btn btn-custom theme-color"
                  >{{ $t('recallForm.send') }}
                  </v-btn>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!--Subscribe section Ends-->
  </div>
</template>
<script>
import {TheMask} from 'vue-the-mask'
import {VueRecaptcha} from 'vue-recaptcha'

export default {
  name: 'RecallForm',
  components: {TheMask, VueRecaptcha},
  data () {
    return {
      name: '',
      company: '',
      phone: '',
      isShow: false,
      token: '',
      captchaVerify: false,
      visible: false,
      phoneValidationMsg: this.$t('recallForm.error.format'),
      sitekey: process.env.CAP_TOKEN
    }
  },
  methods: {
    sendEmail () {
      if (!this.captchaVerify) {
        this.popup(this.$t('recallForm.error.captcha'))
        console.log(`this.capValid ${this.captchaVerify}`)
        return
      }

      if (!this.company) {
        this.popup(this.$t('recallForm.error.requiredCompany'))
        return
      }

      if (!this.name ) {
        this.popup(this.$t('recallForm.error.requiredName'))
        return
      }

      if (this.phone.length > 0 && this.phone.length < 17) {
        this.popup(this.$t('recallForm.error.format'))
        return
      } else if (this.phone.length === 0) {
        this.popup(this.$t('recallForm.error.required'))
        return
      }

      if (this.phone.trim()) {
        let lang = this.$i18n.locale
        switch (this.$i18n.locale) {
          case 'en': {
            lang = 'English'
            break
          }
          case 'uk': {
            lang = 'Українська'
            break
          }
        }
        try {
          fetch(`${process.env.BASE_URL}/api/site/registerRequest`, {
            method: 'POST',
            mode: 'cors',
            headers: {
              'Authorization': `Bearer ${process.env.API_TOKEN}`,
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(
              {
                company: `${this.company}`,
                name: `${this.name}`,
                phone: `${this.phone}`,
                language: `${lang}`
              }
            )
          })
            .then(async response => {
              this.name = ''
              this.company = ''
              this.phone = ''
              this.token = ''
              this.phoneValidationMsg = this.$t('recallForm.error.format')
              this.$refs.recaptcha.reset()

              alert(this.$t('recallForm.emailSend'))
            })
            .then(data => {})
            .catch(error => console.log('error' + error))
        } catch (error) {
          console.error(error)
        }
      }
    },
    popup (text) {
      this.isShow = true;
      this.phoneValidationMsg = text;
      setTimeout(() => {
         this.isShow = false
      }, 2000)
    },
    register (token) {
      // verify token on server
      try {
        fetch(`${process.env.BASE_URL}/api/site/checkCaptcha?token=${token}`, {
          method: 'POST',
          mode: 'cors',
          headers: {
            'Authorization': `Bearer ${process.env.API_TOKEN}`
          }
        })
          .then(async response => {
            let res = await response.text()
            this.captchaVerify = (res === 'true')
          })
          .then(data => console.log('data' + data))
          .catch(error => console.log('error' + error))
      } catch (error) {
        console.error(error)
      }
    },

    validate () {
      // if validate true exec recaptcha
      this.$refs.recaptcha.execute()
      console.log(`validate ${process.env.CAP_TOKEN}`)
    },

    onCaptchaExpired () {
      this.$refs.recaptcha.reset()
      console.log(`onCaptchaExpired ${process.env.CAP_TOKEN}`)
    }
  }

}
</script>



// WEBPACK FOOTER //
// src/components/recallForm.vue